import { Inject, Injectable } from '@angular/core';
import { LENTA_DOMAIN, TESTING_STAND_PROD_REVIEW } from '@lentau/city/shared/constants';
import { Region } from 'angular-api-gateway/v1/model/region';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';
import { CityNavigateHelperService } from './city-navigate-helper.service';

@Injectable({ providedIn: 'root' })
export class CityChangeService {
  constructor(
    private cityNavigationService: CityNavigateHelperService,
    @Inject(WINDOW) private window: Window
  ) {}

  private get domain(): Set<string> {
    const { host } = this.window.location;
    const domainsList: string[] = host.split('.');
    return new Set(domainsList);
  }

  public navigateToDefaultUrl(cities: Region[]): void {
    if (this.isRedirectDisabled()) {
      return;
    }

    const { host } = this.window.location;

    let newHost: string = host;

    const cityName: string = this.getCityNameByHost(cities);

    if (cityName) {
      const slug: string = cityName + '.';
      newHost = host.replace(slug, '');

      this.cityNavigationService.navigate(newHost);
    }
  }

  public navigateToRegion(citySlug: string): void {
    if (this.isRedirectDisabled()) {
      return;
    }

    const { host } = this.window.location;
    const splitHost: string = host.split('.').slice(-this.cityNavigationService.splitHostValue).join('.');
    const newHost: string = citySlug + '.' + splitHost;

    this.cityNavigationService.navigate(newHost);
  }

  public isRedirectDisabled(): boolean {
    // lenta.com с пддоменом города (3 сегмента)
    if (this.isLentaHostWithCity()) {
      return false;
    }

    // Prod-review стенд с городом (5 сегментов)
    if (this.isProdReviewTestingStandWithCity()) {
      return false;
    }

    return true;
  }

  private isProdReviewTestingStandWithCity(): boolean {
    const { host } = this.window.location;
    const splitHost: string[] = host.split('.');
    return host.includes(TESTING_STAND_PROD_REVIEW) && splitHost.length === 5;
  }

  private isLentaHostWithCity(): boolean {
    const { host } = this.window.location;
    const splitHost: string[] = host.split('.');
    return host.includes(LENTA_DOMAIN) && splitHost.length === 3;
  }

  private getCityNameByHost(cities: Region[]): string {
    const citiesList: string[] = cities.map((city: Region) => city.slug);

    for (const cityName of citiesList) {
      if (this.domain.has(cityName)) {
        return cityName;
      }
    }
    return '';
  }
}
